<template>
  <el-timeline>
    <el-timeline-item
      v-for="(activity, index) in activities"
      :key="index"
      :color="activity.color"
      :timestamp="activity.timestamp"
      placement="top"
      size="large"
    >
      <div class="TagGroup">
        <div class="TagCard">
          <div class="TagCard-img-container">
            <img :src="activity.img" :alt="activity.title" />
          </div>
          <div class="Text">
            <h1>{{ activity.title }}</h1>
            <p>
              <strong>{{ activity.desc }}</strong>
            </p>
            <p>{{ activity.motto }}</p>
          </div>
        </div>
      </div>
    </el-timeline-item>
  </el-timeline>
</template>

<script setup lang="ts">
const activities = [
  {
    timestamp: "2023-08",
    color: "#a58037",
    img: require("@/assets/HKUST.png"),
    title: "香港科技大学",
    desc: "CSE Dept.",
    motto: "先驅新進 求變無間 東西春秋 日月可鑑",
  },
  {
    timestamp: "2019-10",
    color: "#b90203",
    img: require("@/assets/同济大学学生会.png"),
    title: "同济大学学生会",
    desc: "采写编辑部",
    motto: "自觉觉人",
  },
  {
    timestamp: "2019-08",
    color: "#0059aa",
    img: require("@/assets/tongji.png"),
    title: "同济大学",
    desc: "软件学院",
    motto: "夫吴人与越人相恶也,当其同舟而济,遇风,其相救也,如左右手",
  },
  {
    timestamp: "2016-09",
    color: "#d41920",
    img: require("@/assets/Kangjie_Middle_School_Logo.png"),
    title: "康杰中学",
    desc: "",
    motto: "问渠那得清如许,为有源头活水来",
  },
];
</script>

<style scoped>
.TagGroup {
  margin: 20px auto 20px;
  width: 80%;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 30px 45px;
}

.TagCard {
  //--tagcard-height: 185px;
  width: 100%;
  //height: var(--tagcard-height);
  max-height: 30vh;
  margin: 0;
  border-radius: 30px;
  box-shadow: -3px -3px 7px #eee, 3px 3px 5px rgb(94 104 121);
  align-self: center;
  display: grid;
  grid-template-columns: 0.7fr 1fr;
  transition: 0.8s cubic-bezier(0.2, 0.8, 0.2, 1);
}

.TagCard-img-container {
  width: 100%;
  height: 100%; /* Set the desired height for all images */
  overflow: hidden;
  position: relative;
  align-items: center;
}

.TagCard-img-container img {
  width: 80%;
  height: 80%;
  margin: 8% 10% auto 10%;
  object-fit: contain; /* Ensures the image covers the container while maintaining its aspect ratio */
}

.Text {
  font-family: "Microsoft JhengHei UI Light", sans-serif;
  padding: 16px;
}

.Text h1 {
  font-size: 2em;
  margin: 5px 0 10px;
}
.Text p {
  font-size: 1.2em;
  margin: 20px auto 10px auto;
}
@media only screen and (max-width: 768px) {
  .Text h1 {
    font-size: 1.1em;
  }
  .Text p {
    font-size: 1em;
  }
}
</style>
